import { FC, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TeamAPI, API } from '@brg/api';
import { useProfile } from '@brg/auth';
import HsePageScraperController from './HsePageScraperController';
import { useRedirectToPromptForms } from 'shared/pages/exploreHseContextsNew/hooks/useRedirectToPromptForms';
import { PromtRedirectStatus } from 'shared/pages/exploreHseContextsNew/const/promptFormsId';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';

interface PromtCourseConfig {
    pageId: string;
    teamContext: string;
    moduleProjectId: string;
    additionalRequiredTags: string[];
}

export const PROMT_COURSES: Record<string, PromtCourseConfig> = {
    'prompt-video': {
        pageId: '7923',
        teamContext: 'prompt-video',
        moduleProjectId: '6f879803bcc842c8b9ae08007e6b607f',
        additionalRequiredTags: ['1344d3b0296e4bdaa589ab4b2194ae3a']
    },
    'prompt-brand': {
        pageId: '7924',
        teamContext: 'prompt-brand',
        moduleProjectId: '5b488948d1674daab6b8cc4288a42ef9',
        additionalRequiredTags: ['92ca3f83c7da46d396fe1010e4e58df1']
    },
    'prompt-code': {
        pageId: '7925',
        teamContext: 'prompt-code',
        moduleProjectId: 'e90d23c67aad4027b11a536948206a19',
        additionalRequiredTags: ['0ecb6880f5594e9282c39fa1f33a20a9']
    },
};

export interface PromtCourseControllerProps {
    courseKey: keyof typeof PROMT_COURSES;
}

export const PromtCourseController: FC<PromtCourseControllerProps> = ({ courseKey }) => {
    const profile = useProfile();
    const history = useHistory();
    const [team, setTeam] = useState<any>(null);
    const [isTeamLoading, setIsTeamLoading] = useState(true);
    const [shouldShowLanding, setShouldShowLanding] = useState(false);

    const promptRedirectingStatus = useRedirectToPromptForms({ 
        teamId: team?.teamId, 
        membersIDs: team?.membersIDs, 
        ownersIDs: team?.ownersIDs,
        designerId: profile?.designerId
    });

    const config = PROMT_COURSES[courseKey];

    useEffect(() => {
        if (!profile) {
            setShouldShowLanding(true);
            setIsTeamLoading(false);
            return;
        }

        TeamAPI.Get({ idTeam: config.teamContext })
            .then((r: any) => r.json())
            .then((teamData) => {
                setTeam(teamData);
                setIsTeamLoading(false);
            })
            .catch(() => {
                setIsTeamLoading(false);
                setShouldShowLanding(true);
            });
    }, [profile, config.teamContext]);

    if (promptRedirectingStatus === PromtRedirectStatus.default) {
        return <LoaderSpinner />
    }

    if (isTeamLoading && profile !== null) {
        return null;
    }

    if (shouldShowLanding) {
        return <HsePageScraperController id={config.pageId} />;
    }

    return null;
};

export default PromtCourseController;

import { FC, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TeamAPI, API } from '@brg/api';
import { useProfile } from '@brg/auth';
import HsePageScraperController from './HsePageScraperController';
import { useRedirectToPromptForms } from 'shared/pages/exploreHseContextsNew/hooks/useRedirectToPromptForms';
import { PromtRedirectStatus } from 'shared/pages/exploreHseContextsNew/const/promptFormsId';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';

interface PromtCourseConfig {
    pageId: string;
    teamContext: string;
    moduleProjectId: string;
    additionalRequiredTags: string[];
}

export const PROMT_COURSES: Record<string, PromtCourseConfig> = {
    'prompt-video': {
        pageId: '7923',
        teamContext: 'prompt-video',
        moduleProjectId: '6f879803bcc842c8b9ae08007e6b607f',
        additionalRequiredTags: ['1344d3b0296e4bdaa589ab4b2194ae3a']
    },
    'prompt-brand': {
        pageId: '7924',
        teamContext: 'prompt-brand',
        moduleProjectId: '5b488948d1674daab6b8cc4288a42ef9',
        additionalRequiredTags: ['92ca3f83c7da46d396fe1010e4e58df1']
    },
    'prompt-code': {
        pageId: '7925',
        teamContext: 'prompt-code',
        moduleProjectId: 'e90d23c67aad4027b11a536948206a19',
        additionalRequiredTags: ['0ecb6880f5594e9282c39fa1f33a20a9']
    },
};

export interface PromtCourseControllerProps {
    courseKey: keyof typeof PROMT_COURSES;
}

export const PromtCourseController: FC<PromtCourseControllerProps> = ({ courseKey }) => {
    const profile = useProfile();
    const history = useHistory();
    const [team, setTeam] = useState<any>(null);
    const [isTeamLoading, setIsTeamLoading] = useState(true);
    const [shouldShowLanding, setShouldShowLanding] = useState(false);

    const promptRedirectingStatus = useRedirectToPromptForms({ 
        teamId: team?.teamId, 
        membersIDs: team?.membersIDs, 
        ownersIDs: team?.ownersIDs,
        designerId: profile?.designerId
    });

    const config = PROMT_COURSES[courseKey];

    useEffect(() => {
        if (!profile) {
            setShouldShowLanding(true);
            setIsTeamLoading(false);
            return;
        }

        TeamAPI.Get({ idTeam: config.teamContext })
            .then((r: any) => r.json())
            .then((teamData) => {
                setTeam(teamData);
                setIsTeamLoading(false);
            })
            .catch(() => {
                setIsTeamLoading(false);
                setShouldShowLanding(true);
            });
    }, [profile, config.teamContext]);

    if (promptRedirectingStatus === PromtRedirectStatus.default) {
        return <LoaderSpinner />
    }

    if (isTeamLoading && profile !== null) {
        return null;
    }

    if (shouldShowLanding) {
        return <HsePageScraperController id={config.pageId} />;
    }

    return null;
};

export default PromtCourseController;

